import React, { useEffect, useState, useRef } from 'react';
import ReactDOM from 'react-dom';
import { X } from 'lucide-react'

import './VideoDocumentation.css';

const VideoDocPopup = ({ isOpen, onClose, ignoreRef, courseData, moduleData }) => {
  const popupRef = useRef(null);

  const [activeSection, setActiveSection] = useState(moduleData[0]?.subModuleName);
  const [videoId, setVideoId] = useState(moduleData[0]?.videoData[0]);

  if (!isOpen) return null;

  const videoLink = (path, video) => {
    console.log(path + '/' + video)
    setVideoId(path + '/' + video);
    console.log(videoId);
  }
  return ReactDOM.createPortal(
    <div className="overlay">
      <div className="fullscreen-popup">
        <div className="popup-inner" >

          <div
            className="d-flex justify-content-right align-items-center"
            style={{ width: '100%', marginBottom: '20px', height: '60px' }}
          >
            <div className="d-flex align-items-center" style={{ gap: '10px', paddingLeft: '20px' }}>
              <div className="config-icon-background-rounded ml-auto cursor-pointer" onClick={onClose}>
                <X size={18} />
              </div>
              <p style={{ paddingLeft: '10px', fontSize: '22px' }}>Video Documentation </p>
            </div>
          </div>
          <div class="d-flex custom-container ">
            <div class="custom-div-left " >
              <video
                key={videoId}
                className="responsive-video"
                controls
                controlsList="nodownload"
                onContextMenu={(e) => e.preventDefault()}
              >
                <source src={videoId} type="video/mp4" />
                Your browser does not support the video tag.
              </video>
            </div>

            <div class="custom-div-right " >

              <div className="sidebar-container">
                <div className="sidebar-header">
                  <div className="header-content">
                    <div className="header-left">
                      <span className="header-title">Assessment</span>
                    </div>
                  </div>
                </div>


                {Object.values(moduleData).map((section, index) => (
                  <div className="sidebar-content" key={index}>
                    <div className="">
                      <button
                        onClick={() => setActiveSection(section?.subModuleName !== activeSection ? section?.subModuleName : '')}
                        className="section-header"
                      >
                        <div className="section-info" >
                          <div className="section-title">{section?.subModuleName}</div>
                          <div className="section-subtitle">{section.videoData?.length} Videos</div>
                        </div>
                        {activeSection == section.subModuleName ?
                          <img src={`${process.env.PUBLIC_URL}/assets/images/ArrowUp.svg`} alt="ArrowUp" style={{ width: 10, height: 10, cursor: 'pointer' }} title="ArrowUp" />
                          :
                          <img src={`${process.env.PUBLIC_URL}/assets/images/ArrowDown.svg`} alt="ArrowDown" style={{ width: 10, height: 10, cursor: 'pointer' }} title="ArrowDown" />

                        }
                      </button>
                      {activeSection === section?.subModuleName && (
                        <div className="videos-list">
                          {section.videoData.map((video, index) => (
                            <button className="video-item" key={index} onClick={() => videoLink(section?.subModuleVideoPath, video)}>
                              <div className="video-thumbnail">
                                <img src={`${process.env.PUBLIC_URL}/assets/images/Play_Video.svg`} alt="Play_Video" style={{ width: 24, height: 24, cursor: 'pointer' }} />
                              </div>
                              <span className="video-title" >
                                {video}
                              </span>
                            </button>
                          ))}
                        </div>
                      )}
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>,
    document.body
  );
};

export default VideoDocPopup;
